import { Component, h, Host } from "@stencil/core";

/**
 * @slot - Slot company logo content
 */
@Component({
  tag: "stzh-company-logo",
  styleUrl: "stzh-company-logo.scss",
  scoped: true,
})
export class StzhCompanyLogo {
  render() {
    const classes = {
      "stzh-company-logo": true,
    };

    return (
      <Host>
        <div class={classes}>
          <div class="stzh-company-logo__image">
            <slot></slot>
          </div>
        </div>
      </Host>
    );
  }
}
